<template>
  <div class="options-container">
    <split-button
      v-if="!isFuture && status !== 'recentParcels' && !inactiveZeroBalance && (useInvoiceCloudPaymentUrl() || payTaxBillUrl)"
    >
      <template slot="primary">
        <a
          v-if="useInvoiceCloudPaymentUrl()"
          class="button-label text-decoration-none"
          rel="noopener"
          title="Click To Pay Tax Bill"
        >
          <div
            class="d-flex align-items-center"
            @click="invoiceCloudClickHandler"
          >
            <DollarSVG class="svg-icon" :fillColor="'white'" />
            <span class="primary-link">Pay Tax Bill</span>
          </div>
        </a>
        <a
          v-else-if="payTaxBillUrl"
          :href="payTaxBillUrl"
          class="button-label text-decoration-none"
          rel="noopener"
          target="_blank"
          title="Click To Pay Tax Bill"
        >
          <div class="d-flex align-items-center">
            <DollarSVG class="svg-icon" :fillColor="'white'" />
            <span class="primary-link">Pay Tax Bill</span>
          </div>
        </a>
      </template>
      <split-content>
        <a
          v-if="useInvoiceCloudPaymentUrl()"
          class="text-decoration-none"
          rel="noopener"
          title="Click To Pay Tax Bill"
          @click.stop="invoiceCloudClickHandler"
        >
          <div class="dropdown-link">
            <DollarSVG class="svg-icon" />
            Pay Tax Bill
          </div>
        </a>
        <a
          v-else-if="payTaxBillUrl"
          :href="payTaxBillUrl"
          class="text-decoration-none"
          rel="noopener"
          target="_blank"
          title="Click To Pay Tax Bill"
          @click.stop
        >
          <div class="dropdown-link ">
            <DollarSVG class="svg-icon" />
            Pay Tax Bill
          </div>
        </a>
        <a
          class="text-decoration-none"
          :href="viewTaxBillUrl || '#'"
          @click.stop
          target="_blank"
          title="Click To View Tax Bill"
          ><div class="dropdown-link ">
            <DollarBillSVG />
            View Tax Bill
          </div></a
        >
      </split-content>
    </split-button>
    <div
      v-if="(isFuture || status === 'recentParcels') && !inactiveZeroBalance"
      class="dropdown-button"
    >
      <a
        class="rounded flex-button mx-3 text-decoration-none button-label"
        id="view-tax-bill"
        @click.stop
        :href="viewTaxBillUrl || '#'"
        target="_blank"
        title="Tax Bill"
      >
        <div class="primary-link">
          <!-- <DollarBillSVG :fillColor="'white'" /> -->
          View Tax Bill
        </div></a
      >
    </div>
    <div v-if="inactiveZeroBalance" class="dropdown-button">
      <a
        v-if="useInvoiceCloudPaymentUrl()"
        class="rounded flex-button mx-3 text-decoration-none button-label"
        rel="noopener"
        title="Click To Pay Tax Bill"
      >
        <div
          class="d-flex align-items-center"
          @click="invoiceCloudClickHandler"
        >
          <DollarSVG class="svg-icon" :fillColor="'white'" />
          <span class="primary-link me-2">Pay Tax Bill</span>
        </div>
      </a>
      <a
        v-else-if="payTaxBillUrl"
        :href="payTaxBillUrl"
        class="rounded flex-button mx-3 text-decoration-none button-label"
        rel="noopener"
        target="_blank"
        title="Click To Pay Tax Bill"
      >
        <div class="d-flex align-items-center">
          <DollarSVG class="svg-icon" :fillColor="'white'" />
          <span class="primary-link me-2">Pay Tax Bill</span>
        </div>
      </a>
    </div>
  </div>
</template>
<style scoped>
#view-tax-bill {
  width: 11rem;
}
.button-inner-text {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
<script>
import SplitButton from "../common/SplitButton.vue";
import SplitContent from "../common/SplitContent.vue";
import DollarBillSVG from "../svg/DollarBillSVG.vue";
import DollarSVG from "../svg/DollarSVG.vue";
export default {
  components: {
    DollarBillSVG,
    DollarSVG,
    SplitButton,
    SplitContent,
  },
  computed: {
    viewTaxBillUrl: function() {
      if (!this.county.corpCode || !this.dup) {
        return;
      }
      return (
        process.env.VUE_APP_TAXBILLSERVICE +
        "?county=" +
        this.county.corpCode +
        "&dup=" +
        this.dup
      );
    },
    payTaxBillUrl() {
      if (!this.county.payTaxBillUrl) {
        return false;
      }
      // InvoiceCloud
      if (this.county.payTaxBillUrl == "InvoiceCloud") {
        return "InvoiceCloud";
      }
      // standard URL w/ optional tokens for either StateKey or UnformattedStateKey
      let url = this.county.payTaxBillUrl;
      url = url.replace("{{DuplicateNumber}}", this.dup);
      url = url.replace("{{StateKey}}", this.stateKey);
      url = url.replace(
        "{{TaxType}}",
        this.taxType.substring(0, 1).toUpperCase()
      );
      url = url.replace("{{UnformattedStateKey}}", this.unformattedStateKey);
      return url;
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  methods: {
    useInvoiceCloudPaymentUrl() {
      return this.county.payTaxBillUrl == "InvoiceCloud";
    },
    invoiceCloudClickHandler() {
      if (!this.county.corpCode || !this.dup) {
        return;
      }
      let openNewWindowRef = window.open(undefined, "_blank");
      this.axios
        .get(process.env.VUE_APP_INVOICECLOUDSERVICE + "/payment-url", {
          params: {
            corpcode: this.county.corpCode.toLowerCase(),
            dup: this.dup,
            payYear:
              this.taxType == "Mobile"
                ? this.currentPayYear
                : this.currentPayYear - 1,
            springAmount: this.SpringBalanceDue,
            fallAmount: this.FallBalanceDue,
          },
        })
        .then((response) => {
          openNewWindowRef.location = response.data.data.CloudPaymentURL;
        })
        .catch(() => {
          openNewWindowRef.close();
          alert("Unable to contact payment provider. Please try again later.");
        });
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    dup: {
      type: Number,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    currentPayYear: {
      type: Number,
      required: false,
    },
    stateKey: {
      type: String,
      required: true,
    },
    unformattedStateKey: {
      type: String,
      required: true,
    },
    currentAccountBalance: {
      type: Number,
      required: false,
    },
    status: {
      // ready|cancelled|searching|error|recentParcels
      required: true,
      type: String,
    },
    taxType: {
      required: true,
      type: String,
    },
    SpringBalanceDue: {
      type: Number,
      required: false,
    },
    FallBalanceDue: {
      type: Number,
      required: false,
    },
    inactiveZeroBalance: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
